<!--
詳細表示可能なツールチップ（楕円形の枠がついたラベル）を表示するモジュール
@props
  data 表示するデータの配列
  max 概要表示時に表示するデータの件数
-->

<template>
  <div class="d-flex flex-row">
    <!-- 詳細、概略のモードを表示するアイコン -->
    <div style="width: 38px; min-width: 38px">
      <v-btn icon v-if="max < data.length" @click="ellipsis = !ellipsis"
        ><v-icon>{{ ellipsisIcon }}</v-icon></v-btn
      >
    </div>
    <!-- ツールチップデータ -->
    <div class="d-flex flex-row flex-wrap">
      <v-tooltip
        bottom
        :open-delay="open_delay"
        v-for="content in this.displayData"
        :key="content.id"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-chip
            :color="content.color"
            dark
            outlined
            class="mr-2 mt-1 mb-1"
            v-bind="attrs"
            v-on="on"
          >
            {{ displayName(content.name) }}
          </v-chip>
        </template>
        <!-- マウスオーバーで表示するコンテンツ -->
        <span v-html="content.detail"></span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data", "max"],
  computed: {
    /**
     * ツールチップに表示するデータを取得する
     * 概略表示モードで、なおかつ表示の上限件数を超える場合は、先頭から上限件数までの数件だけを表示する
     */
    displayData() {
      if (this.ellipsis) {
        return this.data.slice(0, Math.min(this.max, this.data.length));
      } else {
        return this.data;
      }
    },
    /**
     * ツールチップの概略表示/詳細表示時のアイコンを取得する
     */
    ellipsisIcon() {
      if (this.ellipsis) {
        return "mdi-chevron-right";
      }
      return "mdi-chevron-down";
    },
  },
  data() {
    return {
      // 概略表示、省略表示のモード
      ellipsis: true,
      // ツールチップラベルで表示する文字数
      content_max_length: 10,
      // マウスオーバーからメッセージを表示するまでの秒数（ミリ秒）
      open_delay: 1000,
    };
  },
  methods: {
    /**
     * ツールチップラベルの表示文字列を取得する
     * 長い文字列は省略して表示する
     */
    displayName(name) {
      if (name.length <= this.content_max_length) {
        return name;
      }
      return name.substring(0, this.content_max_length) + "…";
    },
    /**
     * 詳細表示、概略表示を切り替える
     */
    setEllipsisState(state) {
      this.ellipsis = state;
    },
  },
};
</script>

<style></style>
